module.exports = {"510132001":"五津街道","510132101":"花桥镇","510132102":"花源镇","510132103":"金华镇","510132104":"普兴镇","510132105":"兴义镇","510132106":"新平镇","510132107":"方兴镇","510132108":"安西镇","510132109":"永商镇","510132110":"邓双镇","510132202":"文井乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510132.json
// module id = 2399
// module chunks = 0